
import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../SideNav/Sidebar";
import Header from "../SideNav/Header";
import Designation from "../../Pages/Admin/Master/Designation/Designation";
import Departments from "../../Pages/Admin/Master/Departments/Departments";
import SubDepartment from "../../Pages/Admin/Master/SubDepartment/SubDepartment";
import KraKpi from "../../Pages/Admin/Master/KraKpi/KraKpi";
import YearOfDuration from "../../Pages/Admin/Master/YearOfDuration/YearOfDuration";
import AddEmployee from "../../Pages/Admin/UserManagement/AddEmployee/AddEmployee";
import EmpoloyeeDetails from "../../Pages/Admin/UserManagement/AddEmployee/EmpoloyeeDetails";
import KrapKpiManagement from "../../Pages/Admin/KrapKpiManagement/KrapKpiManagement";
import KrapKpiManagementHomePage from "../../Pages/Admin/KrapKpiManagement/KrapKpiManagementHomePage";
import OverviewReports from "../../Pages/Admin/Reports/OverviewReports";
import EmployeeSidebar from "../SideNav/EmployeeSidebar";
import MyAppraisal from "../../Pages/Employee/MyAppraisal/MyAppraisal";
import MyAppraisalForm from "../../Pages/Employee/MyAppraisal/MyAppraisalForm";
import TeamAppraisal from "../../Pages/Employee/MyAppraisal/TeamAppraisal/TeamAppraisal";
import TeamAppraisalForm from "../../Pages/Employee/MyAppraisal/TeamAppraisal/TeamAppraisalForm";
import DepartmentAppraisal from "../../Pages/Employee/MyAppraisal/DepartmentAppraisal/DepartmentAppraisal";
import DepartmentAppraisalForm from "../../Pages/Employee/MyAppraisal/DepartmentAppraisal/DepartmentAppraisalForm";
import Dashboard from "../../Pages/Employee/Dashboard/Dashboard";
import EmployeeHeader from "../SideNav/EmployeeHeader";

// import AboutUsManagementAboutUsContentManagement from "../../Pages/ContentManagement/AboutUs/AboutUsContentManagement";
// import SchemeApprovalTabs from "../../Pages/Management/SchemeApproval/SchemeApprovalTabs";

const EmployeeLayout = ({ dynamicLogo }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // const { isLoggedIn, permissions, role } = useSelector((state) => state.auth);
  const [headerTitleName, setHeaderTitleName] = useState("");
  const handleMenuClick = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const role = sessionStorage.getItem("role")
  console.log(role, "roleeeeeeeee");

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: { md: 1.5 },
        backgroundColor: "#F7F7F7",
      }}
    >
      <CssBaseline />
      {/* <Sidebar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} /> */}
      <EmployeeSidebar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} dynamicLogo={dynamicLogo} />
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <EmployeeHeader
          userRole="Employee"
          logoutRouterName="/employeelogin"
          headerTitleName={headerTitleName}
          onMenuClick={handleMenuClick}
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
        />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 2.5, backgroundColor: "#F7F7F7" }}
        >
          {/* <Typography variant='hello'>hello</Typography> */}

          <Routes>

            <Route path="/" element={<Dashboard />} />
            <Route path="myappraisal" element={<MyAppraisal dynamicLogo={dynamicLogo}/>} />
            {/* <Route path="myappraisalform/:krakpiid_employeeid_appraisalyearid" element={<MyAppraisalForm />} /> */}
            <Route path="myappraisalform" element={<MyAppraisalForm />} />

            <Route path="teamappraisal" element={<TeamAppraisal />} />
            <Route path="teamappraisalform" element={<TeamAppraisalForm />} />
            <Route path="departmentappraisal" element={<DepartmentAppraisal />} />
            <Route path="departmentappraisalform" element={<DepartmentAppraisalForm />} />
            <Route path="yearofduration" element={<YearOfDuration />} />
            <Route path="addemployee" element={<AddEmployee />} />
            <Route path="employeedetails" element={<EmpoloyeeDetails />} />
            <Route path="rolewisekrakpi" element={<KrapKpiManagementHomePage />} />
            <Route path="createkrakpi" element={<KrapKpiManagement />} />
            <Route path="overviewreports" element={<OverviewReports />} />







          </Routes>
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeLayout;
